import { render, staticRenderFns } from "./RecommendBox.vue?vue&type=template&id=4acb32cc"
import script from "./RecommendBox.ts?vue&type=script&lang=ts&external"
export * from "./RecommendBox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports